import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { SafeImage } from '@composites/PDF/AgendaPdfContent/components/SafeImage';

export interface NETPromoterScorePageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const NETPromoterScorePage = ({ event, footer }: NETPromoterScorePageProps) => {
  const { t } = useTranslation();

  const titles = [
    'satisfaction-measurement-title',
    'determine-significance-title',
    'net-promoter-score-38-title',
  ];

  const descriptions = [
    'satisfaction-measurement-text',
    'determine-significance-text',
    'net-promoter-score-38-text',
  ];

  const eventYear: number = event?.start_date
    ? new Date(event.start_date).getFullYear()
    : new Date().getFullYear() || 2026;
  const year: string = (eventYear - 1).toString();

  const images: Record<string, string> = {
    '2024':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2025.png',
    '2025':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2025.png',
    '2026':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2026.png',
    '2027':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2027.png',
    '2028':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2028.png',
    '2029':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2029.png',
    '2030':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2030.png',
    '2031':
      'https://media.we-conect.com/images/pdf/partnerprospectus/net_promoter_score_2031.png',
  };

  if (!event) {
    return null;
  }

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{ ...styles.page, overflow: 'hidden' }}
    >
      <View
        style={{
          ...styles.leftColumn,
        }}
      >
        <Text
          style={{ ...styles.highlightText, color: event?.design?.themeColor }}
        >
          Service that convinces:
        </Text>
        <Text style={{ ...styles.title }}>{'NET PROMOTER SCORE'}</Text>
        <Text style={{ ...styles.title }}>{`IN ${year} = 38!`}</Text>

        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
            marginLeft: 0,
          }}
        />

        <Text style={styles.paragraph}>{t('net-promoter-paragraph')}</Text>

        <SafeImage
          style={styles.image}
          src={images?.[year] ?? images['2025']}
        />
      </View>

      <View style={styles.rightColumn}>
        <View style={styles.timelineContainer}>
          <View style={styles.timelineLine} />

          {[0, 1, 2].map((_, index) => (
            <View key={index} style={styles.timelineItem}>
              <View style={styles.iconWrapper}>
                <SafeImage
                  style={styles.icon}
                  src={`https://media.we-conect.com/images/pdf/agenda/rocket_4x.png`}
                />
              </View>
              <View style={styles.timelineContent}>
                <Text style={styles.timelineTitle}>{t(titles[index])}</Text>
                <Text style={styles.timelineText}>
                  {t(descriptions[index])}
                </Text>
              </View>
            </View>
          ))}
        </View>
        <Text style={styles.arrowSymbol}>v</Text>
      </View>

      {footer}
    </Page>
  );
};

export default NETPromoterScorePage;
